import './CollapsedFundList.scss';
import classNames from 'classnames';

export const IRAAutoMaxCollapsed = ({
  clickable,
  onEditClick,
  selectedFundsCount,
}) => {
  if (!selectedFundsCount) {
    return null;
  }
  return (
    <div
      className={classNames(
        'collapsed-fund-list-header',
        'e2e-collapsed-fundlist',
        {
          'collapsed-fund-list-pointer': clickable,
          'collapsed-fund-list-non-pointer': !clickable,
        }
      )}
      onClick={clickable ? onEditClick : undefined}
    >
      IRA AutoMax selected for {selectedFundsCount} funds.
      <a
        className="college-branded-link collapsed-fund-list-edit-link"
        id="funds-list-edit-link"
      >
        Edit
      </a>
    </div>
  );
};

export default IRAAutoMaxCollapsed;
